export const vech = {
  data: [{
    title: '出售2018款本田雅阁',
    distance: '5万公里',
    time: '2018年5月',
    pailiang: '1.5T',
    biansu: '自动',
    paifang: '国五',
    public: "李先生",
    mobile: '13882475693',
    xianjia: '12万元',
    yuanjia: '18万元',
    imgs: ['/img/车辆买卖/1.webp', '/img/车辆买卖/本田.png', '/img/车辆买卖/本田1.png', '/img/车辆买卖/本田2.png'],
    description: `1、成都本市私家一手车，基本成都市区行驶，路况好车况好公里数较少，
2、原车主比较爱惜保养的很好，原版原漆，漆水闪亮有光泽（已做完抛光打蜡保 养），
3、内饰干净整洁无异味比较新，基本没什么磨损，整体养护都很不错现场来看车相信您会满意！
4、无任何事故火烧水泡，支持任何第三方检测，检测完再买都可以，免费试乘试驾体验，
 `
  }, {
    title: '转让2017款丰田凯美瑞',
    distance: '6万公里',
    time: '2017年8月',
    pailiang: '2.0L',
    biansu: '自动',
    paifang: '国五',
    public: "张女士",
    mobile: '13908123478',
    xianjia: '14万元',
    yuanjia: '20万元',
    imgs: ['/img/车辆买卖/2.webp', '/img/车辆买卖/凯美瑞.png', '/img/车辆买卖/凯美瑞1.png', '/img/车辆买卖/凯美瑞2.png'],
    description: `外观：漆面保养良好，车身结构复，无重大事故。 
内饰：干净整洁。安全指示灯正常，气囊等被动安全项正常，车辆内电子器件使用良好，
驾驶：车辆点火、起步、提速、过弯、减速、制动均无问题，加速迅猛，动力输出平稳舒 无怠速抖动。
整体：整体车况精品。车体骨架结构无变形扭曲、无火烧泡水痕迹。
`
  }, {
    title: '转让2015款现代途胜',
    distance: '8.5万公里',
    time: '2015年12月',
    pailiang: '2.0L',
    biansu: '自动',
    paifang: '国五',
    public: "杨先生",
    mobile: '15760301289',
    xianjia: '11万元',
    yuanjia: '22万元',
    imgs: ['/img/车辆买卖/3.webp', '/img/车辆买卖/现代.png', '/img/车辆买卖/现代1.png', '/img/车辆买卖/现代2.png'],
    description: `外观：漆面保养良好，车身结构复，无重大事故。 
内饰：干净整洁。安全指示灯正常，气囊等被动安全项正常，
驾驶：车辆点火、起步、制动均无问题，加速迅猛，动力输出平稳舒 无怠速抖动。 
整体：车身没有喷漆痕迹，整体漆面良好，视野宽阔，空间宽敞明亮通风性好，适合家庭代步车
`
  }, {
    title: '出售2016款宝马3系',
    distance: '7万公里',
    time: '2016年3月',
    pailiang: '2.0T',
    biansu: '自动',
    paifang: '国五',
    public: "王先生",
    mobile: '18228015643',
    xianjia: '18万元',
    yuanjia: '30万元',
    imgs: ['/img/车辆买卖/4.webp', '/img/车辆买卖/宝马.png', '/img/车辆买卖/宝马1.png'],
    description: `家用代步车，发动机，变速箱正常无异响，
动力强劲，价格实惠，外观时尚大气，
内饰干净整洁
`
  }, {
    title: '出售2019款奥迪A4L',
    distance: '3万公里',
    time: '2019年10月',
    pailiang: '2.0T',
    biansu: '自动',
    paifang: '国六',
    public: "赵先生",
    mobile: '1308204785',
    xianjia: '22万元',
    yuanjia: '35万元',
    imgs: ['/img/车辆买卖/5.webp', '/img/车辆买卖/奥迪.png', '/img/车辆买卖/奥迪1.png'],
    description: `三大件质保3年10万公里，购车出茶博士检测报告，
车子支持全款分期
事故火烧水泡退一赔三写购车合同
`
  }, {
    title: '转让2015款奔驰C级',
    distance: '8万公里',
    time: '2015年7月',
    pailiang: '2.0T',
    biansu: '自动',
    paifang: '国五',
    public: "刘女士",
    mobile: '13181079032',
    xianjia: '16万元',
    yuanjia: '28万元',
    imgs: ['/img/车辆买卖/6.webp', '/img/车辆买卖/奔驰.png', '/img/车辆买卖/奔驰1.png'],
    description: `6、本车已经过实地检测，为非事故、非火烧、非泡水车
车况，原版原漆带车衣，车子支持任何检测，
动力强劲，内饰干净整洁
`
  }, {
    title: '出售2020款特斯拉Model 3',
    distance: '1.5万公里',
    time: '2020年6月',
    pailiang: '2.0T',
    biansu: '自动',
    paifang: '零排放',
    public: "孙先生",
    mobile: '15682091475',
    xianjia: '28万元',
    yuanjia: '35万元',
    imgs: ['/img/车辆买卖/7.webp', '/img/车辆买卖/特使啦.png', '/img/车辆买卖/特斯拉.png'],
    description: `1确保无大事故无水泡，无火烧，无发动机修过，公里数真实 
2车况必须精品，不是精品车况会在电话里提前告知 
3所有车辆照片均为实车拍照 
4所有车辆包过户提档无需车辆购置税 
`
  }, {
    title: '出售2014款福特翼虎',
    distance: '9万公里',
    time: '2014年4月',
    pailiang: '1.5T',
    biansu: '自动',
    paifang: '国五',
    public: "周女士",
    mobile: '13382052691',
    xianjia: '9万元',
    yuanjia: '20万元',
    imgs: ['/img/车辆买卖/8.webp', '/img/车辆买卖/福特.png', '/img/车辆买卖/福特1.png'],
    description: `整体:整体车况良好。车体骨架结构无变形扭曲、
无火烧泡水痕迹。,整体漆面良好,排除大事故车辆。
`
  }, {
    title: '转让2017款大众帕萨特',
    distance: '6.5万公里',
    time: '2017年11月',
    pailiang: '1.8T',
    biansu: '自动',
    paifang: '国五',
    public: "吴先生",
    mobile: '15382083504',
    xianjia: '13万元',
    yuanjia: '24万元',
    imgs: ['/img/车辆买卖/9.webp', '/img/车辆买卖/大众.png', '/img/车辆买卖/大众1.png'],
    description: `车况必须精品，承诺无任何重大事故；
车辆行驶里程真实可靠； 
车辆其他年款颜色店内均有售；
已上牌无需缴纳车辆购置税； 
`
  }, {
    title: '出售2018款日产天籁',
    distance: '4万公里',
    time: '2018年1月',
    pailiang: '2.0L',
    biansu: '自动',
    paifang: '国五',
    public: "何女士",
    mobile: '18082068712',
    xianjia: '15万元',
    yuanjia: '22万元',
    imgs: ['/img/车辆买卖/10.webp', '/img/车辆买卖/日产.png', '/img/车辆买卖/日产1.png'],
    description: `所有在售车源均为在店实车，非中介，无套路，全款按揭均可。
除所标车价外无任何费用，欢迎带专业人士前来验车！
欢迎来电或微聊咨询，恭候光临联系我
`
  }, {
    title: '转让2016款雪佛兰迈锐宝',
    distance: '7.5万公里',
    time: '2016年9月',
    pailiang: '2.0L',
    biansu: '自动',
    paifang: '国五',
    public: "韩先生",
    mobile: '13882509417',
    xianjia: '10万元',
    yuanjia: '18万元',
    imgs: ['/img/车辆买卖/11.webp', '/img/车辆买卖/雪佛兰.png', '/img/车辆买卖/雪佛兰1.png'],
    description: `外观：漆面保养良好，车身结构复，无事故。 
内饰：干净整洁。安全指示灯正常，车内静态动态设备完善。
 驾驶：车辆点火、起步、提速、过弯、减速、动力输出平稳舒 适,无怠速抖动。 
整体：整体车况精品。车体骨架结构无变形扭曲、无火烧泡水痕迹。整体漆面良好，排除事故车辆
`
  }, {
    title: '出售2019款吉利博越',
    distance: '2.5万公里',
    time: '2019年3月',
    pailiang: '1.8T',
    biansu: '自动',
    paifang: '国六',
    public: "陈女士",
    mobile: '13201297390',
    xianjia: '12万元',
    yuanjia: '16万元',
    imgs: ['/img/车辆买卖/12.webp', '/img/车辆买卖/吉利.png', '/img/车辆买卖/吉利1.png'],
    description: `个人家用一手车，车况精品无事故泡水，支持任何第三方检测，
原版无碰撞,发动机保养良好, 定期更换机油、底盘 无杂音、
平时保养细致 外表漆面较好 少量补漆 内饰新、换挡顺畅 、发动机动力强劲 、
手续正规齐全,可享受一年两万公里质保，欢迎看实车，价格可议！
`
  }]
}